module.exports = __webpack_public_path__ + "static/img/lisa.015d91e0.png";